module.exports = __webpack_public_path__ + "img/ic-blokk.0c3af958.svg";